"use client"
/* */
const getColumns = (values) => {
  const fractionValues = values.filter((v) => v !== null).map((value) => `${value}fr`);
  return fractionValues.join(" ");
};

export { getColumns };
//# sourceMappingURL=getColumns.mjs.map
